import { DateTime } from 'luxon'
import { Container, ActionBlock, InfoText } from './styles'

export default function AuditLog ({
  data: auditLog,
  onSelect: handleSelect = () => null
}) {
  return (
    <Container onClick={() => handleSelect (auditLog)}>
      <InfoText>
        {DateTime.fromISO (auditLog.created_at).toFormat ('dd/MM/yyyy - HH:mm')}
      </InfoText>
      <InfoText>
        {auditLog.user?.name || 'Usuário Desconhecido'}
      </InfoText>
      <InfoText>
        {auditLog.table_name_readable}
      </InfoText>
      <ActionBlock action={auditLog.action}>
        {auditLog.action_readable}
      </ActionBlock>
    </Container>
  )
}
